<template>
  <v-row class="px-6">
    <v-col cols="12" md="4">
      <v-text-field
          @input="searchFunc"
          v-model="filterData.search"
          clearable
          class="rounded-xl pr-0 sm-font400-14"
          append-icon="mdi-magnify"
          label="جستجو"
          outlined
          hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
          :items="categoryArchiveList"
          class="rounded-xl sm-font400-14"
          label="وضعیت دسته"
          item-text="text"
          item-value="id"
          hide-details
          clearable
          v-model="filterData.is_active"
          @change="searchFunc"
          outlined
      ></v-select>
    </v-col>
    <v-col cols="12" md="2">
      <v-btn
          block
          color="primary"
          @click="showToggleStatusByIds = true"
          class="white--text rounded-xl sm-font400-13"
          elevation="0"
          height="56"
          :disabled="ids.length === 0"
      >فعال/غیرفعال کردن
      </v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-btn
          block
          color="positive"
          @click="showAddCategory = true"
          class="white--text rounded-xl sm-font400-13"
          elevation="0"
          height="56"
      >افزودن دسته
      </v-btn>
    </v-col>
          <v-col cols="12" md="2">
            <v-btn
              block
              outlined
              @click="exportExcel"
              class="thirdColor--text rounded-xl sm-font400-13"
              height="56"
            >
            <v-icon>mdi-upload</v-icon>
            خروجی اکسل
            </v-btn>
          </v-col>
    <v-dialog v-model="showToggleStatusByIds" width="500" @click:outside="clearList">
      <v-card class="pa-10  text-center rounded-xl">
        <h3 class="mb-5">آیا از فعال/غیرفعال کردن دسته بندی ها مطمئن
          هستید؟</h3>
        <v-btn :loading="loading" @click="confirmToggleStatusByIds" block color="positive"
               class="white--text rounded-xl mt-3" height="48">ارسال
        </v-btn>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showAddCategory" width="850">
      <v-card class="pa-10 rounded-xl">
        <div class="d-flex align-center justify-space-between mb-7">
<!--          <v-icon class="me-3">mdi-arrow-right</v-icon>-->
          <p class="mb-0 sm-font600-16 textColorSecond--text">ایجاد دسته بندی</p>
          <v-btn icon @click="showAddCategory = false" aria-label="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-form>
          <v-row>
            <v-col class="py-1" md="6" cols="12">
              <label>عنوان دسته بندی</label>
              <v-text-field
                  v-model="categoryData.title"
                  class="rounded-lg mt-1 pr-0 sm-font400-14"
                  solo
                  single-line
                  hide-details
              ></v-text-field>
            </v-col>
            <v-col class="py-1" cols="12" md="6">
              <label>تصویر دسته بندی</label>
              <v-file-input
                  v-model="categoryData.image"
                  accept="image/*"
                  prepend-icon=""
                  append-icon="mdi-upload"
                  class="rounded-lg mt-2 sm-font400-14"
                  solo
                  hide-details
                  @change="changedImage"
              >
                <template slot="prepend-inner" v-if="imagePreview">
                  <a target="_blank" :href="imagePreview" class="d-flex align-center">
                    <v-avatar size="32" class="me-2">
                      <v-img :src="imagePreview" />
                    </v-avatar>
                    <span class="sm-font400-12">پیش‌نمایش</span>
                  </a>
                </template>
              </v-file-input>
        
            </v-col>
            
            <v-col class="py-1" cols="12" md="6">
              <label>بارگزاری فایل توضیحات دوره</label>
              <v-file-input v-model="categoryData.description_file" prepend-icon="" append-icon="mdi-upload"
                            class="rounded-lg mt-2 sm-font400-14" solo hide-details></v-file-input>
            </v-col>
            <v-col cols="12">
              <label>توضیحات</label>
              <v-textarea v-model="categoryData.description" class="rounded-lg mt-2 sm-font400-14" rows="3" hide-details
                          solo></v-textarea>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                  color="positive"
                  class="textColor--text sm-font500-16 rounded-xl me-3"
                  depressed
                  height="48"
                  width="230"
                  :loading="loadingAddCat"
                  @click="submitAddCategory"
              >
                ثبت
              </v-btn>

              <v-btn width="230" height="48" depressed color="nagative"
                     class="textColor--text sm-font500-16 rounded-xl" @click="showAddCategory = false">
                انصراف
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import courseApi from "@/Services/modules/courses"

export default {
  name: "filter-page",
  props: {
    ids: {
      type: Array,
    },
  },
  data() {
    return {
      loading: false,
      loadingAddCat: false,
      showAddCategory: false,
      showToggleStatusByIds: false,
      imagePreview: "",
      imageObjectUrl: "",
      categoryArchiveList: [
        {
          id: true,
          text: "فعال"
        },
        {
          id: false,
          text: "غیرفعال",
        }
      ],
      filterData: {
        page: Number(this.$route.query.page) || 1,
        search: this.$route.query.search || "",
      },
      categoryData: {
        // is_shown: true
      },
    }
  },
  methods: {
    searchFunc() {
      this.$router.push({
        query: {
          ...this.$route.query,
          search: this.filterData.search,
          is_archive: false,
        }
      })
      this.$emit("getData", this.filterData)
    },
    clearList() {
      this.$emit("clearIdList")
    },
    submitAddCategory() {
      this.loadingAddCat = true
      // Always send فعال to api
      this.categoryData.is_active = true
      courseApi.addNewCategory(this.categoryData)
        .finally(() => {
          this.categoryData = {
            // is_shown: true
          }
          this.showAddCategory = false
          this.imagePreview = ""
          try {
            if (this.imageObjectUrl) URL.revokeObjectURL(this.imageObjectUrl)
          } catch (e) {
            // ignore
          } finally {
            this.imageObjectUrl = ""
          }
          this.$emit("getData", {...this.$route.query, is_archive: false})
        })
        .finally(() => {
          this.loadingAddCat = false
        })
    },
    changedImage(file) {
      // If user selects a new local file, show a true preview (blob URL).
      // If they clear the selection, hide the preview.
      try {
        if (this.imageObjectUrl) URL.revokeObjectURL(this.imageObjectUrl)
      } catch (e) {
        // ignore
      } finally {
        this.imageObjectUrl = ""
      }

      if (!file) {
        this.imagePreview = ""
        return
      }

      const selected = Array.isArray(file) ? file[0] : file
      if (selected instanceof File) {
        this.imageObjectUrl = URL.createObjectURL(selected)
        this.imagePreview = this.imageObjectUrl
        return
      }

      if (typeof selected === "string") {
        this.imagePreview = selected
      }
    },
    confirmToggleStatusByIds() {
      courseApi.multipleStatusActionOnCategory({ids: this.ids, is_active: true}).finally(() => {
        this.showToggleStatusByIds = false
        this.$emit("getData", {...this.$route.query, is_archive: false})
      })
    },
    exportExcel() {
      courseApi.getCategoryExcel().then((response) => {
        window.open(URL.createObjectURL(response.data));
      })
    }
  },
  beforeDestroy() {
    try {
      if (this.imageObjectUrl) URL.revokeObjectURL(this.imageObjectUrl)
    } catch (e) {
      // ignore
    }
  }
}
</script>

<style scoped>

</style>
